import PropTypes from 'prop-types';

import { countWords } from '../util/counter';

export const WordCounter = ({ text }) => {
  const count = countWords(text);

  if (count === 0) {
    return null;
  }

  return (
    <span className='compose-form__word-counter'>
      {count} {count > 1 ? 'mots' : 'mot'}
    </span>
  );
};

WordCounter.propTypes = {
  text: PropTypes.string.isRequired,
};
